// project-params.component.ts
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ProjectParametersService } from '@app/services/project-parameters.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { UnsavedChangesService } from '@app/services/unsaved-changes.service';
@Component({
  selector: 'app-project-params',
  templateUrl: './project-parameters.component.html'
})
export class ProjectParametersComponent implements OnInit {
 form!: FormGroup;
  templates: any[] = [];
  layouts: any[] = [];
projectId: string = '';
  private unsavedWired = false;

  constructor(
    private fb: FormBuilder,
    private ProjectParametersService: ProjectParametersService,
    private route: ActivatedRoute,
    private router: Router,
    private unsaved: UnsavedChangesService
  ) {}


  ngOnInit(): void {

    //debugger;
    this.projectId =  this.route.snapshot.params['shortcode'];
  
 
    this.form = this.fb.group({
      projectId: [this.projectId],
      templateId: [''],
      layoutIds: [[]],
      projectDefaultLayoutSC: [''],
      customFields: this.fb.array([]),
      projectAudioStrategy: ['SLIDE'],
      projectBreakOnNewline: ['N'],
      audioOptions: this.fb.array([])
    });

    // Load dropdown data
    this.ProjectParametersService.getTemplates().subscribe(data => this.templates = data);
    this.ProjectParametersService.getLayouts().subscribe(data => this.layouts = data);
    console.log(this.templates);
    // Load saved project data for editing
    this.ProjectParametersService.getProjectParams(this.projectId).subscribe(saved => {
      if (saved) {
          let layoutidarr = JSON.parse(saved.projectLayoutsSC);
        this.form.patchValue({
          templateId: saved.projectTemplateShortCode,
          layoutIds: layoutidarr || [],
          projectDefaultLayoutSC: saved.projectDefaultLayoutSC || '',
          projectAudioStrategy: saved.projectAudioStrategy || 'SLIDE',
          projectBreakOnNewline: saved.projectBreakOnNewline || 'N',
        });

        // Prefill custom fields
        if (saved.projectSpecificFields) {
           let cfarr = JSON.parse(saved.projectSpecificFields);
          cfarr.forEach((cf: any) => {
            this.customFields.push(this.fb.group({
              name: [cf.name],
              value: [cf.value]
            }));
          });
        }

        // Prefill audio options (JSON array)
        if (saved.projectAudioOptions) {
          try {
            const aopts = JSON.parse(saved.projectAudioOptions);
            if (Array.isArray(aopts)) {
              aopts.forEach((ao: any) => {
                this.audioOptions.push(this.fb.group({
                  key: [ao.key || ''],
                  language: [ao.language || ao.Language || ''],
                  voice: [ao.voice || ''],
                  voiceSpeed: [ao['voice-speed'] ?? ao.voiceSpeed ?? 1],
                  voiceVolume: [ao['voice-volume'] ?? ao.voiceVolume ?? 'Standard'],
                }));
              });
            }
          } catch (e) {
            // ignore malformed saved json; allow user to fix by adding options
          }
        }
      }
      this.form.markAsPristine();
      this.unsaved.setDirty(false);
      if (!this.unsavedWired) {
        this.unsavedWired = true;
        this.form.valueChanges.subscribe(() => {
          if (this.form.dirty) {
            this.unsaved.setDirty(true);
          }
        });
      }
    });
  }

  get customFields(): FormArray {
    return this.form.get('customFields') as FormArray;
  }

  get audioOptions(): FormArray {
    return this.form.get('audioOptions') as FormArray;
  }

  addCustomField(): void {
    this.customFields.push(this.fb.group({
      name: [''],
      value: ['']
    }));
  }

  removeCustomField(index: number): void {
    this.customFields.removeAt(index);
  }

  addAudioOption(): void {
    this.audioOptions.push(this.fb.group({
      key: [''],
      language: [''],
      voice: [''],
      voiceSpeed: [1],
      voiceVolume: ['Standard'],
    }));
  }

  removeAudioOption(index: number): void {
    this.audioOptions.removeAt(index);
  }

  onLayoutChange(event: any) {
    const layoutIds: string[] = this.form.value.layoutIds || [];
    if (event.target.checked) {
      layoutIds.push(event.target.value);
    } else {
      const index = layoutIds.indexOf(event.target.value);
      if (index > -1) {
        layoutIds.splice(index, 1);
      }
    }
    const patch: { layoutIds: string[]; projectDefaultLayoutSC?: string } = { layoutIds };
    const currentDefault = String(this.form.value.projectDefaultLayoutSC || '');
    if (currentDefault && !layoutIds.includes(currentDefault)) {
      patch.projectDefaultLayoutSC = '';
    }
    this.form.patchValue(patch);
  }

  save(): void {
    console.log(this.form.value);
    this.ProjectParametersService.saveProjectParams(this.form.value)
      .subscribe(() => {
        this.form.markAsPristine();
        this.unsaved.setDirty(false);
        alert('Saved successfully!');
      });
  }
}

